import { Stack, Unstable_Grid2 as Grid } from '@mui/material';
import { useForm } from 'react-final-form';

import {
  ProductGroupSelectField,
  ToggleButtonGroupField,
  Select,
  OnChange,
  FuelRollbackAmountField,
} from '@occc-app/design-system';
import { Typography } from '@occc/ui-design-system';
import { Breakage_Point_Rounding } from '@occc/graphql';

export const FuelRollbackFormContent = () => {
  const form = useForm();

  return (
    <>
      <OnChange name='voucherStackingConstraint.breakageRefund'>
        {(value: boolean) => {
          const isTransactionLimitEnabled =
            form.getState().values.awardCount?.isEnabled &&
            form.getState().values.awardCount?.transaction?.isEnabled;
          const isAnyLimitValueSpecified = Boolean(
            form.getState().values.awardCount?.transaction?.limit ||
              form.getState().values.awardCount?.global?.limit ||
              form.getState().values.awardCount?.membership?.limit,
          );

          // Close "Set Fulfillment Limits" section if no values
          if (!value && !isAnyLimitValueSpecified) {
            form.change('awardCount.isEnabled', false);
            form.change('awardCount.transaction.isEnabled', false);
            form.change('awardCount.global.isEnabled', false);
            form.change('awardCount.membership.isEnabled', false);
            return;
          }

          // Enable Per Transaction Fulfillment limit when breakageRefund enabled
          if (value && !isTransactionLimitEnabled) {
            form.change('awardCount.isEnabled', true);
            form.change('awardCount.transaction.isEnabled', true);
          }
        }}
      </OnChange>

      <Grid container>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            Give Members:
          </Typography>
        </Grid>
        <Grid xs={3}>
          <FuelRollbackAmountField name='fuelRollback.amount' />
        </Grid>
      </Grid>

      <Grid container sx={{ pt: 3 }}>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            For the following:
          </Typography>
        </Grid>
        <Grid xs={12}>
          <ProductGroupSelectField
            data-testid='product-groups-input'
            inputProps={{
              margin: 'none',
            }}
            name='fuelRollback.productGroups'
            label='Product groups'
          />
        </Grid>
      </Grid>

      <Grid container sx={{ pt: 3 }}>
        <Grid xs={12}>
          <Typography variant='subtitle1' paragraph>
            Refund eligible
          </Typography>
        </Grid>
        <Grid xs={12}>
          <Stack direction='row' spacing={1}>
            <ToggleButtonGroupField
              name='voucherStackingConstraint.breakageRefund'
              buttons={[
                { title: 'No', value: false, key: 'No' },
                { title: 'Yes', value: true, key: 'Yes' },
              ]}
            />
            <Select
              label='Round'
              name='voucherStackingConstraint.breakagePointRounding'
              sx={{ maxWidth: 200 }}
              data={[
                {
                  label: 'Round UP',
                  value: Breakage_Point_Rounding.RoundUp,
                },
                {
                  label: 'Round DOWN',
                  value: Breakage_Point_Rounding.RoundDown,
                },
              ]}
            />
          </Stack>
        </Grid>
      </Grid>
    </>
  );
};
